import { Component, Input } from '@angular/core';
import { DashboardResponse } from '../../../api/models/dashboardResponse';

@Component({
    selector: 'rejected-aged-expired2',
    template: require('./rejected-aged-expired2.component.html')
})

export class RejectedAgedExpired2Component {

    public ham: boolean = false;
    phoneNumberFixed: string = '';

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;

    constructor() {
        /* empty */
    }

    ngOnInit() {
        this.phoneNumberFixed = this.dataSearch.phoneNumber.substr(15, 14).split('-').join('');
    }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }

    searchInformation() {
        /* empty */
    }
}